import { atom } from 'recoil';
import { EHintType } from 'pages/calculation/consts/hint-types.consts';
import { TCheckedType } from 'pages/calculation/types/index.type';

type TInputParameters = {
  length?: string;
  width?: string;
  height?: string;
  layerThickness?: string;
  areaUser?: number;
};

type TSize = {
  height: string;
  width: string;
};

type TDoors = {
  quantity: number | null;
  sizes: TSize[] | null;
};

type TWindows = TDoors;

type TTotal = {
  area: number;
  requiredQuantity: number;
  requiredVolume?: number;
  volume?: number;
};

type TItemSurfaceParams = {
  area: number;
  requiredQuantity: number;
  requiredVolume?: number;
};

type TItem = {
  productId: string;
  surface: {
    WALL?: TItemSurfaceParams;
    FLOOR?: TItemSurfaceParams;
    CEILING?: TItemSurfaceParams;
  };
  total: TTotal;
};

type TSurfaceParams = {
  baseSurface: string;
  typeInstallation?: string;
};

type TSurface = {
  WALL?: TSurfaceParams;
  FLOOR?: TSurfaceParams;
  CEILING?: TSurfaceParams;
};

type TServices = {
  name: string;
  priceMin: number;
};

type TValueProduct = {
  value: string[];
};

export type TTotalComplimentaryProduct = {
  requiredQuantity: number;
};

type TCharacteristics = {
  ATT_00543: number;
  ATT_00124: number;
};

export type TComplimentaryProductInfo = {
  productId: string;
  characteristics?: TCharacteristics;
  total: TTotalComplimentaryProduct;
  product_page_name: TValueProduct;
  displayedName: TValueProduct;
  mediaMainPhoto: TValueProduct;
  salesPriceValueInConsumerUnitValue: number;
};

export type TState = {
  inputParameters: TInputParameters;
  doors?: TDoors;
  windows?: TWindows;
  items: TItem[];
  surface: TSurface;
  hints?: EHintType[];
  services: TServices[] | [];
  complimentaryProductInfo: TComplimentaryProductInfo[] | [];
  checkedProducts: TCheckedType | [];
};

export const dimensionsAtom = atom({
  key: 'dimensions',
  default: {
    inputParameters: {},
    items: [],
    surface: {},
    services: [],
    complimentaryProductInfo: [],
    checkedProducts: [],
  } as TState,
});

export const dimensionsFormValues = atom({
  key: 'dimensionFormValues',
  default: {},
});
